import { Button } from "antd";
import React from "react";

const DefaultButton = ({ className, style, children, htmlType, loading, onClick }) => {
  return (
    <Button
      htmlType={htmlType}
      loading={loading}
      className={`${className} px-10 py-4 text-white hover:text-green-200 text-[16px] font-semibold flex items-center justify-center border-0 rounded-3xl`}
      style={{
        background:
          "linear-gradient(269.43deg, #C1DC5B -85.17%, #5A741D 109.14%)",
        minHeight: "38px",
        minWidth: "100px",
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default DefaultButton;
